import { showWait } from '@zyno-io/vue-foundation';

import { softphoneMgr } from '@/modules/talk/shared/softphone.manager';

import { Logger } from '../services/logger';
import { UpdateChecker, useIdleUpdateNotifier } from './update.helpers';

const logger = Logger.createScoped('UpdateReload');

// Never reload out from under an active call or an open modal. Registered here rather than in
// update.helpers so the CX bundle doesn't pull in the softphone; every reload path consults it.
UpdateChecker.registerReloadBlocker(() => softphoneMgr.getActiveCalls().value.length > 0 || document.querySelector('.vf-modal') !== null);

// Reload the app for a pending update once the user has been idle for timeoutMs.
// Shared by the login screen and the main app shell so the pre-checks stay in
// sync: never reload out from under an active call or an open modal. The idle
// check re-runs every ~10s (see useIdleTimeout), so it retries once both clear.
//
// Lives apart from update.helpers (which the CX forms embed imports) so the
// softphone dependency doesn't get pulled into that separate bundle.
export function useIdleUpdateReload(timeoutMs: number) {
    useIdleUpdateNotifier(timeoutMs, () => {
        if (!UpdateChecker.canReloadNow()) return;
        logger.info('Reloading ZynoSuite for update');
        showWait('Updating ZynoSuite...');
        window.location.reload();
    });
}
